export default "__VITE_ASSET__ffefcd5f__"